import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AlertController, IonicModule } from '@ionic/angular';
import { AnalyzedConsumption } from 'src/app/services/analyse/analyse.types';
import { MeteorologyObservations, MeteorologyForecast } from 'src/app/services/meteorologi/meteorologi.types';
import { BoxWrapperComponent } from '../box-wrapper/box-wrapper.component';
import {
  analyseNettleieRoute,
  analyseRoute,
  spotprisRoute
} from 'src/app/routes';
import { UsageCostDayComponent } from './usage-cost/usage-cost-day.component';
import { UsageCostMonthComponent } from './usage-cost/usage-cost-month.component';
import { PricesForbrukComponent } from './prices-forbruk/prices-forbruk.component';
import { NettleieAdvisoryComponent } from '../nettleie/advisory/advisory.component';
import { PricesForbrukDashboardComponent } from './prices-forbruk/prices-forbruk-dashboard.component';
import { AnalyseDayChartUsageComponent } from './day-chart-usage/analyse-day-chart-usage.component';
import { Anlegg } from 'src/app/services/forbruk/forbruk.types';

@Component({
  selector: 'app-forbruk-analyse',
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    BoxWrapperComponent,
    UsageCostDayComponent,
    UsageCostMonthComponent,
    PricesForbrukComponent,
    NettleieAdvisoryComponent,
    PricesForbrukDashboardComponent,
    AnalyseDayChartUsageComponent
  ],
  templateUrl: './forbruk.component.html',
  styleUrl: './forbruk.component.scss'
})
export class ForbrukAnalyseComponent {
  valgtAnlegg: Anlegg;
  analyzedConsumption: AnalyzedConsumption;
  meteorologyObservations: MeteorologyObservations;
  meteorologyForecast: MeteorologyForecast;
  errorAnalyse: boolean = false;
  hasNoConfig: boolean = false;
  netteier: string;
  objectid: string;
  valgtAdresse: string;
  selectedDate: Date = new Date();
  monthName = new Date().toLocaleString('no-NO', { month: 'short' });
  dayChartUsageTitle = `Forbruk mot temperatur for ${this.monthName}.`;

  // lastUpdated: string;
  // lead =
  //   'Dette er en analyse av ditt forbruksmønster. Tall oppdateres daglig kl 12.';

  constructor(
    private _alertController: AlertController,
    private router: Router
  ) {
    const state = this.router.getCurrentNavigation().extras?.state;

    if (state) {
      this.analyzedConsumption = state.analyzedConsumption;
      this.errorAnalyse = state.errorAnalyse;
      this.hasNoConfig = state.hasNoConfig;
      this.netteier = state.netteier;
      this.objectid = state.objectid;
      this.valgtAdresse = state.valgtAdresse;
      this.valgtAnlegg = state.valgtAnlegg;
      this.meteorologyObservations = state.meteorologyObservations;
      this.meteorologyForecast = state.meteorologyForecast;
    }
  }

  ngOnInit() { }

  goToAnalyse() {
    this.router.navigate([analyseRoute]);
  }

  goToNettleie() {
    const navExtras = {
      state: {
        analyzedConsumption: this.analyzedConsumption.nettleietrinn,
        netteier: this.netteier,
        errorAnalyse: this.errorAnalyse,
        hasNoConfig: this.hasNoConfig,
        valgtAdresse: this.valgtAdresse
      }
    };
    this.router.navigate([analyseNettleieRoute], navExtras);
  }

  getLastUpdated(date: string) {
    const y = Number(date.substring(0, 4));
    const m = Number(date.substring(4, 6)) - 1;
    const d = Number(date.substring(6, 8));
    return new Date(y, m, d).toLocaleString('no-NO', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  async expandTooltip() {
    const message = `<p>
      Her kan du se hvordan forbruket ditt er, og beløp som kan være mulig å spare.  Analysen vektlegger når du bruker strømmen og de høyeste timene. Dette sammenlignes opp mot andre forbrukere de siste 30 dagene.
    </p> `;

    const initalert = await this._alertController.create({
      cssClass: 'push-alert',
      mode: 'ios',
      header: 'Ditt forbruksmønster',
      message,
      buttons: ['Lukk']
    });
    await initalert.present();
  }

  navigateToSpot() {
    const navigationExtras: NavigationExtras = {
      state: {
        activeChart: 'Time',
        presentation: 'table'
      }
    };
    this.router.navigate([spotprisRoute], navigationExtras);
  }
}
